import DOMPurify from 'dompurify';
import Turndown from 'turndown';
import Showdown from 'showdown';

const showdown = new Showdown.Converter({
  simpleLineBreaks: true,
  literalMidWordUnderscores: true,
});

const turndown = new Turndown({
  headingStyle: 'atx',
  bulletListMarker: '-',
  emDelimiter: '_',
  br: '',
});
// The apps and the BO do not all read backslash escapes: `5 \* 3` would show the backslash.
turndown.escape = (text) => text;
turndown.addRule('listItem', {
  filter: 'li',
  replacement(content, node, options) {
    const text = content.replace(/^\n+/, '').replace(/\n+$/, '\n').replace(/\n/gm, '\n  ');
    const list = node.parentNode;
    const prefix = list.nodeName === 'OL'
      ? `${Number(list.getAttribute('start') || 1) + Array.prototype.indexOf.call(list.children, node)}. `
      : `${options.bulletListMarker} `;
    return prefix + text + (node.nextSibling && !text.endsWith('\n') ? '\n' : '');
  },
});

// Markdown each untouched editor value came from: html -> md cannot be lossless,
// so a text nobody edited is sent back exactly as it was received.
const sources = new Map();

const normalize = (html) => {
  const template = document.createElement('template');
  template.innerHTML = html;
  return template.innerHTML;
};

const isHtml = (text) => /^\s*<(p|ul|ol|div|h[1-6]|blockquote)[\s>]/i.test(text);

export const sanitizeHtml = (html) => DOMPurify.sanitize(html || '');

// Showdown would delete a `[Note]: text` line as a link reference definition.
const keepReferenceLines = (md) => md.replace(/^( {0,3})\[([^\]\n]+)\]:/gm, '$1\\[$2]:');

export const renderMd = (md) => sanitizeHtml(showdown.makeHtml(keepReferenceLines(md || '')));

export const htmlToMd = (html) => {
  if (!html) {
    return null;
  }
  const key = normalize(html);
  return sources.has(key) ? sources.get(key) : turndown.turndown(html);
};

export const mdToHtml = (md) => {
  if (!md) {
    return null;
  }
  const html = renderMd(md);
  // A new template is prefilled from the HTML of the form, which is not a source.
  if (!isHtml(md)) {
    sources.set(normalize(html), md);
  }
  return html;
};

export default {
  htmlToMd,
  mdToHtml,
  renderMd,
  sanitizeHtml,
};
